import '@progress/kendo-ui/css/web/kendo.common-material.css';
import '@progress/kendo-ui/css/web/kendo.material.css';
import 'bootstrap/dist/css/bootstrap.css';
import 'jquery-ui/themes/base/all.css';
import './styles/common/common.css';
import './styles/common/page-header.css';
import './styles/login/login.css';

import { loadTemplatesAndApplyBindings } from './scripts';
import './scripts/common/dropdown';
import './scripts/common/helperFunctions';
import './scripts/common/mixins';
import './scripts/common/modalDialog';
import './scripts/common/pageHeader';
import './scripts/common/runAfter';
import './scripts/login/forgotLoginUI';
import './scripts/elasticAPM';

loadTemplatesAndApplyBindings();
